import React, { useEffect, useState, } from 'react';
import FacetMultiSelectComponent from './facetComponent/FacetMultiSelectComponent/FacetMultiSelectComponent';
import FacetSingleSelectComponent from './facetComponent/FacetSingleSelectComponent/FacetSingleSelectComponent';
import { useTranslation } from 'react-i18next';

export const FilterSearchResults = ({ searchResults, onFilterChange, facetName, isAll, selectFirst = true,facetOptionResults, setFacetOptionResults, ...props }) => {
    const { t } = useTranslation();
    let loading = false;
    const [isSingleSelection, setIsSingleSelection] = useState(false);


    const handleNav = (event) => {
        event.stopPropagation();
        event.preventDefault();

        let targetElmClass = event.target.getAttribute("data-for") || event.currentTarget.getAttribute("data-for");
        let navElm = document.querySelector(`.sd-tableContent.${targetElmClass}`);
        let dropdownMenu = navElm?.querySelector(".sd-dropdown-inner-menu");
        let closeBtn = navElm?.querySelector("button.sd-closeBtn");
        if (navElm) {
            if (navElm.classList.contains("sd-expanded")) {
                navElm.classList.remove("sd-expanded");
                if (navElm.classList.contains("sd-trapFocus")) {
                    navElm.classList.remove("sd-trapFocus");
                }
                if (event.target.getAttribute("data-target")) {
                    document.querySelector(`.${event.target.getAttribute("data-target")}`)?.focus();
                }
                if (!dropdownMenu?.classList.contains("lg:sd-hidden")) {
                    dropdownMenu?.classList.add("lg:sd-hidden");
                }
            } else {
                if (!navElm.classList.contains("sd-expanded")) {
                    navElm.classList.add("sd-expanded");
                    closeBtn.focus();
                    if (!navElm.classList.contains("sd-trapFocus")) {
                        navElm.classList.add("sd-trapFocus");
                    }
                }
            }
            // toggleOverlay();
        }
        const targetId = event.currentTarget.getAttribute("id");
        if (targetId) {
            closeBtn.setAttribute("data-targetId", targetId);
        }

    }

    useEffect(() => {
        setIsSingleSelection(props?.isSingleSelection)
        if (searchResults) {
            const updatedFacetOptions = [...searchResults].map((x) => ({
                docType: x.docType,
                docCount: x.docCount,
                selected: false,
            }));
            if (isAll) {
                updatedFacetOptions.unshift({
                    docType: 'All Results',
                    docKey: 'all',
                    docCount: searchResults.reduce((total, x) => total + (x.docCount || 0), 0),
                    selected: true,
                });
                setFacetOptionResults(updatedFacetOptions);
            }
            else {
                if (updatedFacetOptions[0])
                    updatedFacetOptions[0].selected = selectFirst;
                filterSelectedOptions = updatedFacetOptions.filter(item => item.selected).map(item => item.docType);
                onFilterChange(filterSelectedOptions);
                setFacetOptionResults(updatedFacetOptions);
            }
        }
        else {
            setFacetOptionResults([]);
        }
    }, [searchResults]);

    let filterSelectedOptions = [];
    const filterSelectedOption = (option) => {
        console.log(option, "option");
        // option from facetResults
        let newFacetOptions = [];
        loading = true;
        setFacetOptionResults(newFacetOptions);
        if (option?.docKey !== 'all' || option?.docType !== 'All Results') {
            newFacetOptions = facetOptionResults.map((facetOption) => {
                if (facetOption?.docType === option?.docType) {
                    return { ...facetOption, selected: !facetOption.selected };
                }
                if (facetOption?.docKey === 'all') {
                    return { ...facetOption, selected: false };
                }

                return facetOption;

            });
            setFacetOptionResults(newFacetOptions);
        }
        else {
            newFacetOptions = facetOptionResults.map((facetOption) => {
                if (facetOption?.docKey === 'all') {
                    return { ...facetOption, selected: true };
                }
                else {
                    return { ...facetOption, selected: false };
                }
            });

            setFacetOptionResults(newFacetOptions);
        }
        filterSelectedOptions = newFacetOptions.filter(item => item.selected).map(item => item.docType);
        onFilterChange(filterSelectedOptions);
        loading = false;

        if(window.utag_data){
            let selectedFilter = option.docType;
            let searchCount = option.docCount;
            window.utag_data = {
                ...window.utag_data,
                filterBy: selectedFilter === "All Results" ? "All" : selectedFilter,
                searchTermsCount: searchCount
            }
        }
    }

    const filterSingleSelection = (option) => {
        let newFacetOptions = facetOptionResults.map((facetOption) => {
            if (facetOption?.docType === option?.docType) {
                return { ...facetOption, selected: !facetOption.selected }; // Toggle the selected state

            }
            else {
                return { ...facetOption, selected: false };
            }

        })
        setFacetOptionResults(newFacetOptions);
        filterSelectedOptions = newFacetOptions.filter(item => item.selected).map(item => item.docType);
        onFilterChange(filterSelectedOptions);
        if (props?.getSelectedOptions) {
            props.getSelectedOptions(facetName, filterSelectedOptions)
        }
    }


    function toggleOverlay() {
        let overlay = document.getElementById("overlay");
        if (overlay.classList.contains("sd-hidden")) {
            showOverlay();
        } else {
            hideOverlay();
        }
    }
    function hideOverlay() {
        setTimeout(() => {
            let overlay = document.getElementById("overlay");
            let body = document.body;
            if (overlay && !overlay.classList.contains("sd-hidden")) {
                overlay.classList.add("sd-hidden");
            }
            if (body.classList.contains("sd-overflow-hidden")) {
                body.classList.remove("sd-overflow-hidden");
                document.body.style.paddingRight = "";
            }
        }, 300)
    }
    function showOverlay() {
        let overlay = document.getElementById("overlay");
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        let body = document.body;
        let viewportWidth = window.innerWidth;
        if (overlay && overlay.classList.contains("sd-hidden")) {
            overlay.classList.remove("sd-hidden")
        }
        if (!body.classList.contains("sd-overflow-hidden") && viewportWidth > 1024) {
            body.classList.add("sd-overflow-hidden");
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
    }





    return (

        <React.Fragment >
            <div className="sd-h-full  ">
                <div className="sd-navigation sd-w-full">
                    {facetOptionResults.length >= 1 && (
                        <div className="sd-mt-4 lg:sd-mt-0 sd-hidden lg:sd-block">
                            <div className="sd-grid sd-grid-cols-12 sd-gap-4 lg:sd-border-none sd-border-b">
                                <div className="sd-pl-4 sd-sdList lg:sd-col-span-8 sd-col-span-4 sd-mt-[2rem] ">
                                    <h1 className="sd-uppercase ">{facetName ? facetName : t('filterBy')}</h1>
                                </div>
                            </div>
                        </div>
                    )}
                    {searchResults && (
                        <div className="lg:sd-hidden sd-fixed sd-w-full sd-bottom-0 sd-h-[52px] sd-bg-gray-103 sd--mx-4 sd-z-30 sd-py-2">
                            <div className="sd-relative sd-grid sd-grid-cols-8 sd-w-full">
                                <div className="sd-absolute sd-w-max sd--top-16 sd-left-0 sd-right-0 sd-mx-auto sd-flex">

                                    <button onClick={(event) => handleNav(event)} data-for="sd-filterBlock" className="navBtn  sd-uppercase sd-text-xs sd-text-white  sd-bg-gray-103 sd-rounded-full  sd-py-4 sd-px-6 sd-z-50">
                                        {t('filterBy')}
                                    </button>
                                </div>
                            </div>
                            <div className="sd-grid sd-grid-cols-8">
                                <span className="sd-font-sf sd-mb-[9px] sd-text-white sd-text-center sd-block sd-col-span-8 sd-flex sd-justify-center sd-items-center sd-text-xs">
                                    <svg className="sd-mr-2" width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.908203 8.78687H5.0918C5.65869 8.78687 5.93555 8.50562 5.93555 7.89038V4.66479C5.93555 4.11108 5.70703 3.82544 5.23682 3.7771V2.66968C5.23682 1.01294 4.15137 0.213135 3 0.213135C1.84863 0.213135 0.763184 1.01294 0.763184 2.66968V3.79907C0.763184 3.86499 0.33252 4.14624 0.0644531 4.66479V7.89038C0.0644531 8.50562 0.341309 8.78687 0.908203 8.78687ZM1.4707 2.57739C1.4707 1.47437 2.17822 0.889893 3 0.889893C3.82178 0.889893 4.5293 1.47437 4.5293 2.57739V3.77271L1.4707 3.7771V2.57739Z" fill="white" fillOpacity="0.5"></path>
                                    </svg>
                                    <a href="http://www.sandisk.com" className="sd-text-decoration-none">sandisk.com</a></span>
                                <span className="sd-h-[5px] sd-bg-white sd-text-center sd-block sd-w-full sd-col-span-4 sd-col-start-3 sd-mx-auto sd-rounded-full"></span>
                            </div>
                        </div>
                    )}
                    <div className="sd-tableContent sd-filterBlock  sd-pt-0 sd-pb-11 lg:sd-pb-0 sd-fixed lg:sd-relative sd-w-full sd-text-white lg:sd-text-black sd-z-30 lg:sd-relative sd-tableContent sd-grey-bg sd-backdrop-blur-tf lg:sd-bg-transparent sd-rounded-t-lg lg:rounded-none sd--mx-4 lg:sd-mx-0">
                        <div className=" sd-max-content-width sd-mx-auto">
                            <div className="sd-px-4 sd-pt-[14px] lg:sd-pt-0">
                                <div className="sd-grid sd-grid-cols-8 sd-gap-4 lg:sd-gap-0 sd-sticky lg:sd-relative sd-top-0 sd-border-b lg:sd-border-none sd-pb-[14px] lg:sd-pb-0 sd-block lg:sd-hidden sd-mb-6">
                                    <div className="lg:sd-py-4 lg:sd-border-b lg:sd-col-span-8 sd-col-span-8 sd--mx-4 sd-px-4">
                                        <div className="sd-flex sd-justify-between sd-items-center">
                                            <h3 className="sd-mb-0 lg:sd-mb-[7px] sd-block sd-leading-lineHeight120 sd-text-n-offwhite lg:sd-text-black">
                                                {t('filterBy')}</h3>
                                            <button onClick={(event) => handleNav(event)} data-for="sd-filterBlock" className="sd-bg-white sd-rounded-full sd-min-w-6 sd-min-h-6 lg:sd-hidden sd-flex sd-items-center sd-justify-center sd-fill-black  sd-closeBtn">
                                                <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.41808 3.06255L4.63617 4.84446L6.41808 6.62637L5.90896 7.13548L4.12706 5.35357L2.34515 7.13548L1.83603 6.62637L3.61794 4.84446L1.83603 3.06255L2.34515 2.55343L4.12706 4.33534L5.90896 2.55343L6.41808 3.06255Z" fill="black"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="sd-custom-radio-btn sd-mt-2">
                                    {!isSingleSelection && <FacetSingleSelectComponent
                                        facetOptionResults={facetOptionResults}
                                        filterSelectedOption={filterSelectedOption}
                                        loading={loading}
                                    />}
                                    {isSingleSelection && <FacetMultiSelectComponent
                                        facetOptionResults={facetOptionResults}
                                        filterSelectedOption={filterSelectedOption}
                                        loading={loading}
                                    />}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>

    )
}

export default FilterSearchResults;